import { useContext } from 'react';

import { TimeseriesChartAnnotationsDataContext } from '../context/TimeseriesChartAnnotationsData.context.js';

export const useTimeseriesChartAnnotationsData = () =>
  useContext(TimeseriesChartAnnotationsDataContext);
